import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit
} from '@angular/core';
import { WidgetPanelChart } from 'src/app/interfaces/widget-panel-chart';
import { ToastService } from 'src/app/services/toast.service';

import { TitleContentWidgetComponent } from '../title-content-widget/title-content-widget.component';

@Component({
  selector: 'app-chart-widget',
  templateUrl: './chart-widget.component.html',
  styleUrls: ['./chart-widget.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChartWidgetComponent
  extends TitleContentWidgetComponent
  implements OnInit
{
  constructor(
    private ToastService: ToastService,
    private elementRefChart: ElementRef
  ) {
    super(elementRefChart);
  }

  @Input() widgetPanelCharts: WidgetPanelChart[] = [];

  override ngOnInit(): void {
    super.ngOnInit();
    if (!this.widgetPanelCharts) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing widget panel collection from chart widget.'
      );
    }
  }
}
